import axios from "axios";

export default {
    state: {
        appliedFilters: [],
        currentFilter: false,
        filterCount: 0,
        itemCache: [],
        searchQuery: "",
        filterData: [],
        isInit: false,
    },

    getters: {
        filterCount: (state) => {
            return state.appliedFilters.length;
        },
        appliedFilterLabels: (state) => {
            let labels = state.appliedFilters.map((item) => {
                return {
                    filter: item.filter,
                    labels: item.labels,
                };
            });
            return {
                topics:
                    labels
                        .filter((item) => item.filter == "topics")
                        .map((x) => x.labels.join(", "))[0] || "",
                countries:
                    labels
                        .filter((item) => item.filter == "countries")
                        .map((x) => x.labels.join(", "))[0] || "",
                // scope:
                //     labels
                //         .filter((item) => item.filter == "scope")
                //         .map((x) => x.labels.join(", "))[0] || "",
                status:
                    labels
                        .filter((item) => item.filter == "status")
                        .map((x) => x.labels.join(", "))[0] || "",
            };
        },
        appliedFilterIDs: (state) => {
            let ids = state.appliedFilters.map((item) => {
                return {
                    filter: item.filter,
                    ids: item.ids,
                };
            });
            return {
                topics:
                    ids
                        .filter((item) => item.filter == "topics")
                        .map((x) => x.ids.join(", "))[0] || "",
                countries:
                    ids
                        .filter((item) => item.filter == "countries")
                        .map((x) => x.ids.join(", "))[0] || "",
                // scope:
                //     ids
                //         .filter((item) => item.filter == "scope")
                //         .map((x) => x.ids.join(", "))[0] || "",
                status:
                    ids
                        .filter((item) => item.filter == "status")
                        .map((x) => x.ids.join(", "))[0] || "",
            };
        },
        searchQuery: (state) => {
            return state.searchQuery;
        },
        filterData: (state) => {
            return state.filterData;
        },
        filterIsInit: (state) => {
            return state.isInit;
        },
    },

    mutations: {
        // update filters
        RESET_FILTERS(state) {
            state.appliedFilters = [];
            state.currentFilter = false;
            state.searchQuery = "";
        },
        // update filters
        UPDATE_FILTERS(state, n) {
            state.appliedFilters = n;
        },
        // set current filters
        SET_FILTER_COUNT(state, n) {
            state.filterCount = n;
        },
        // set current filters
        SET_CURRENT_FILTER(state, n) {
            state.currentFilter = n;
        },
        SET_ITEM_CACHE(state, n) {
            state.itemCache = n;
        },
        UPDATE_SEARCH_QUERY(state, n) {
            state.searchQuery = n;
        },
        INIT_FILTERS(state, n) {
            state.filterData = n;
            state.isInit = true;
        },
    },

    actions: {
        // reset filters
        resetFilters({ commit }) {
            commit("RESET_FILTERS");
        },
        // update filters
        updateFilters({ state, dispatch, commit }, payload) {
            let filters = state.appliedFilters;
            // apply filter
            if (payload.checked == true) {
                const filter = {
                    filter: payload.filter,
                    ids: [payload.filterID],
                    labels: [payload.filterLabel],
                };
                if (!filters.some((e) => e.filter === payload.filter)) {
                    filters.push(filter);
                } else {
                    if (
                        !filters[
                            filters.findIndex(
                                (e) => e.filter === payload.filter
                            )
                        ].ids.includes(payload.filterID)
                    ) {
                        filters[
                            filters.findIndex(
                                (e) => e.filter === payload.filter
                            )
                        ].ids.push(payload.filterID);
                        filters[
                            filters.findIndex(
                                (e) => e.filter === payload.filter
                            )
                        ].labels.push(payload.filterLabel);
                    }
                }
                // remove filter
            } else {
                if (
                    filters[
                        filters.findIndex((e) => e.filter === payload.filter)
                    ].ids.length
                ) {
                    let ids =
                        filters[
                            state.appliedFilters.findIndex(
                                (e) => e.filter === payload.filter
                            )
                        ].ids;
                    let labels =
                        filters[
                            state.appliedFilters.findIndex(
                                (e) => e.filter === payload.filter
                            )
                        ].labels;
                    if (ids.includes(payload.filterID)) {
                        const index = ids.indexOf(payload.filterID);
                        ids.splice(index, 1);
                        if (ids.length === 0) {
                            const results = filters.filter((item) => {
                                return item.filter !== payload.filter;
                            });
                            filters = results;
                        }
                    }
                    if (labels.includes(payload.filterLabel)) {
                        const index = labels.indexOf(payload.filterLabel);
                        labels.splice(index, 1);
                        if (labels.length === 0) {
                            const results = filters.filter((item) => {
                                return item.filter !== payload.filter;
                            });
                            filters = results;
                        }
                    }
                }
            }
            commit("UPDATE_FILTERS", filters);
            dispatch("filter", {
                checked: payload.checked,
                currentFilter: payload.filter,
            });
        },

        // filter projects
        filter({ state, rootState, dispatch }) {
            let results = [],
                filteredItems = [],
                reducedFilterItems = [],
                reducedFilteredItems = [],
                reducedFilteredItemsLast = [];

            rootState.projects.items.forEach((item) => {
                let reducedFilterItem = {
                    id: item.id,
                    topics: item.topics.map((a) => a.id),
                    countries: item.countries.map((a) => a.id),
                    // scope: item.scope.map((a) => a.id),
                    status: item.status.map((a) => a.id),
                };
                reducedFilterItems.push(reducedFilterItem);
            });

            state.appliedFilters.forEach((filterItem) => {
                const filter = filterItem.filter;
                const filterIDs = filterItem.ids;

                results = reducedFilterItems.filter((item) => {
                    const itemIDs = item[filter].map((a) => a);
                    return filterIDs.some((id) => itemIDs.includes(id));
                });
                reducedFilterItems = results;
                reducedFilteredItems.push(results);
            });

            reducedFilteredItemsLast =
                reducedFilteredItems.pop() || rootState.projects.items;
            if (reducedFilteredItemsLast);
            filteredItems = rootState.projects.items.filter((item) =>
                reducedFilteredItemsLast.some(
                    (reducedItem) => item.id === reducedItem.id
                )
            );

            dispatch("updateItems", filteredItems);
        },

        // filter projects by search term
        filterBySearchTerm({ state, commit, dispatch, rootState }, payload) {
            let filterItems;

            commit("UPDATE_SEARCH_QUERY", payload);
            if (state.appliedFilters.length > 0) {
                filterItems = rootState.projects.filteredItems;
            } else {
                filterItems = rootState.projects.items;
            }

            let results = filterItems.filter((item) => {
                // search only in specific fields
                let match = false;
                Object.keys(item).forEach((key) => {
                    if (
                        key === "organisation" ||
                        key === "title" ||
                        key === "countries" ||
                        key === "topics"
                    ) {
                        if (
                            JSON.stringify(item[key])
                                .toLowerCase()
                                .indexOf(payload.toLowerCase()) !== -1
                        ) {
                            match = true;
                        }
                    }
                });
                return match;

                // full text search
                // if(JSON.stringify(item).toLowerCase().indexOf(payload.toLowerCase()) !== -1) return true;
                // return false;
            });

            dispatch("updateItems", results);
        },
        // initially get items from rest api
        async initFilters({ commit, getters }) {
            try {
                const response = await axios.get(getters.apiConfig.FILTERS_URL);
                commit("INIT_FILTERS", response.data.data[0]);
            } catch (err) {
                // Handle Error Here
                console.error(err);
            }
        },
    },
};
